import ComponentButtons from './ComponentButtons';

export default ComponentButtons;